export type RumRuntimeConfig = {
  debugConsole: boolean
  enabled: boolean
  endpoint: string | undefined
  quickTrackingEnabled: boolean
  useQuickTrackingTransport: boolean
}

/** RUM bootstrap 和主 SDK 必须共享同一套启用判定。 */
export const getRumRuntimeConfig = (): RumRuntimeConfig => {
  const debugConsole = process.env.NEXT_PUBLIC_RUM_DEBUG_CONSOLE === 'true'
  const endpoint = process.env.NEXT_PUBLIC_RUM_ENDPOINT
  const quickTrackingEnabled = process.env.NEXT_PUBLIC_RUM_QT_ENABLED
    ? process.env.NEXT_PUBLIC_RUM_QT_ENABLED === 'true'
    : Boolean(process.env.NEXT_PUBLIC_QUICK_TRACKING_APP_KEY)
  const useQuickTrackingTransport = !endpoint && quickTrackingEnabled
  const enabled = process.env.NEXT_PUBLIC_RUM_ENABLED
    ? process.env.NEXT_PUBLIC_RUM_ENABLED === 'true'
    : Boolean(endpoint || debugConsole || useQuickTrackingTransport)

  return {
    debugConsole,
    enabled,
    endpoint,
    quickTrackingEnabled,
    useQuickTrackingTransport,
  }
}
